import { render, staticRenderFns } from "./GlobalVariableLink.vue?vue&type=template&id=4fbf80c1"
import script from "./GlobalVariableLink.vue?vue&type=script&lang=js"
export * from "./GlobalVariableLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports